import React from "react";
import { TagPicker, IBasePickerStyles } from "@fluentui/react/lib/Pickers";
import { useId } from "@fluentui/react-hooks";
import "./searchbox.scss";
interface Iprops {
  placeholder: string;
  className?: string;
  onChange?: any;
  width?: any;
  height?: any;
  value?: any;
  data?: any;
  customstyle?: any;
  selectionAriaLabel?: any;
  onResolveSuggestions?: any;
  onItemSelected?: any;
  itemLimit?: any;
  pickerSuggestionsProps?: any;
  getTextFromItem?: any;
  defaultSelectedItems?: any;
  onInputChange?: any;
  selectedItems?: any;
  componentRef?: any;
    
}
const Search = ({
  placeholder,
  className,
  width,
  height,
  onChange,
  value,
  data,
  customstyle,
  selectionAriaLabel,
  onResolveSuggestions,
  onItemSelected,
  onInputChange,
  getTextFromItem,
  pickerSuggestionsProps,
  defaultSelectedItems,
  itemLimit,
  selectedItems,
  componentRef,
  
}: Iprops) => {
  const style: Partial<IBasePickerStyles> = {
    input: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "99% 3px",
      backgroundSize: "12px",
      fontSize: "12px",
      width: "180px",
    },
  };
  const pickerId = useId("inline-picker");

  return (
    <TagPicker
      styles={customstyle ?? style}
      removeButtonAriaLabel="Remove"
      resolveDelay={200}
      onDismiss={() => {
        return false;
      }}
      selectionAriaLabel={selectionAriaLabel ?? ""}
      defaultSelectedItems={defaultSelectedItems}
      selectedItems={selectedItems}
      onResolveSuggestions={onResolveSuggestions}
      onItemSelected={onItemSelected}
      onChange={onChange}
      onInputChange={onInputChange}
      getTextFromItem={getTextFromItem}
      pickerSuggestionsProps={pickerSuggestionsProps}
      itemLimit={itemLimit ?? 100}
      pickerCalloutProps={{ doNotLayer: true }}
      componentRef={componentRef }
      inputProps={{
        id: pickerId,
        width: "180px",
        placeholder: placeholder,
        title: placeholder,
      }}
    />
  );
};

export default Search;
